import axios from "axios";
import { apiUrl } from '../../constants/config';

export default {
  state: {
    alerts: [],
    },
  getters: {
    getAlerts: (state) => {
      return state.alerts;
    },
  },
  mutations: {
    DO_NOTHING() {},
    ADD_ALERT(state, payload) {
      state.alerts = payload;
    },
  },
  actions: {
    getAllAlerts({ commit,state }, {user_email}) {
        axios
          .get(apiUrl+"/api/auth/alerts?user_email="+user_email, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: 'Bearer ' + localStorage.getItem('authToken')
            }
          }
          )
          .then((response) => {
            console.log(response)
            const data = response.data;
            const alerts = [];
            data.forEach(function(item){
              alerts.push(item)
            })
            
            commit("ADD_ALERT", alerts);
          });
      },

    saveAlert({commit,state}, {payload}){
      return axios.post(apiUrl+"/api/auth/alerts",payload, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: 'Bearer ' + localStorage.getItem('authToken')
        }
      }).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
  
  removeAlert( { commit,state },{id}) {
    return axios
                .delete(apiUrl+"/api/auth/alerts/"+id,{
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: 'Bearer ' + localStorage.getItem('authToken')
                  }
                }).then(res => {

                }).catch(err => {
                })
  },
}
};
